import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import { MdInfoOutline } from 'react-icons/md';

export default function FormFieldHelp({ children, label = 'Entenda esta configuração' }) {
    return <Tooltip title={<span>{children}</span>} arrow placement="top" enterTouchDelay={0} classes={{ tooltip: 'configuration-help-tooltip' }}>
        <button type="button" className="configuration-field-help hidethis" aria-label={label}><MdInfoOutline aria-hidden="true" /></button>
    </Tooltip>;
}
